(() => {
  const roots = [...document.querySelectorAll('[data-itcc-category-nav]')];
  if (!roots.length) return;

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const buildFilterHtml = (raw, mode, baseUrl, viewLabel) => {
    const groups = String(raw || '')
      .split(';;;')
      .map((group) => group.trim())
      .filter(Boolean);

    if (!groups.length) return '';

    if (mode === 'mega') {
      const cols = groups
        .map((group) => {
          const [titlePart, optsPart = ''] = group.split(':::');
          const title = (titlePart || '').trim();
          const opts = optsPart
            .split(',')
            .map((opt) => opt.trim())
            .filter(Boolean)
            .map((opt) => {
              const [label, tag = ''] = opt.split('|');
              const href = `${baseUrl}/${encodeURIComponent(tag.trim())}`;
              return `<li><a href="${escapeHtml(href)}">${escapeHtml((label || '').trim())}</a></li>`;
            })
            .join('');
          return `<div class="itcc-category-nav__mega-col"><p class="itcc-category-nav__mega-heading">${escapeHtml(
            title
          )}</p><ul class="itcc-category-nav__mega-list" role="list">${opts}</ul></div>`;
        })
        .join('');

      return `<div class="itcc-category-nav__mega-panel"><div class="itcc-category-nav__mega-top"><a class="itcc-category-nav__mega-viewall" href="${escapeHtml(
        baseUrl
      )}">${escapeHtml(viewLabel)}</a></div><div class="itcc-category-nav__mega-inner">${cols}</div></div>`;
    }

    const accordion = groups
      .map((group) => {
        const [titlePart, optsPart = ''] = group.split(':::');
        const title = (titlePart || '').trim();
        const opts = optsPart
          .split(',')
          .map((opt) => opt.trim())
          .filter(Boolean)
          .map((opt) => {
            const [label, tag = ''] = opt.split('|');
            const href = `${baseUrl}/${encodeURIComponent(tag.trim())}`;
            return `<li><a href="${escapeHtml(href)}">${escapeHtml((label || '').trim())}</a></li>`;
          })
          .join('');

        return `<details class="itcc-nav-acc__group"><summary class="itcc-nav-acc__summary"><span>${escapeHtml(
          title
        )}</span><svg class="itcc-nav-acc__chevron" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M2.5 4.5L6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg></summary><ul class="itcc-nav-acc__list" role="list">${opts}</ul></details>`;
      })
      .join('');

    return `<div class="itcc-nav-acc"><a class="itcc-nav-acc__viewall" href="${escapeHtml(
      baseUrl
    )}">${escapeHtml(viewLabel)}</a>${accordion}</div>`;
  };

  const hydrateLazyFilters = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('template[data-itcc-filter-lazy]').forEach((tpl) => {
      const mode = tpl.getAttribute('data-mode') || 'mega';
      const baseUrl = tpl.getAttribute('data-base-url') || '';
      const viewLabel = tpl.getAttribute('data-view-label') || 'View All';
      const raw = tpl.content?.textContent?.trim() || tpl.textContent?.trim() || '';
      const html = buildFilterHtml(raw, mode, baseUrl, viewLabel);
      if (!html) {
        tpl.remove();
        return;
      }
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const node = wrap.firstElementChild;
      if (node) tpl.replaceWith(node);
      else tpl.remove();
    });
  };

  roots.forEach((nav) => {
    const root = nav.closest('.shopify-section') || nav.parentElement;
    if (!root) return;

    const shopAll = root.querySelector('[data-itcc-shop-all]');
    const trigger = root.querySelector('[data-itcc-shop-all-trigger]');
    const menu = root.querySelector('[data-itcc-shop-all-menu]');
    const scroller = root.querySelector('[data-itcc-nav-scroll]');
    const catItems = [...root.querySelectorAll('[data-itcc-cat-item]')];
    const megas = [...root.querySelectorAll('[data-itcc-cat-mega]')];
    let openHandle = null;

    const shopAllCats = [...root.querySelectorAll('[data-itcc-shopall-cat]')];
    let openShopAllHandle = null;

    const setShopAllSubOpen = (handle) => {
      openShopAllHandle = handle || null;
      if (menu) menu.classList.toggle('has-submenu-open', Boolean(handle));

      shopAllCats.forEach((item) => {
        const h = item.getAttribute('data-itcc-shopall-cat');
        const active = Boolean(handle) && h === handle;
        item.classList.toggle('is-open', active);
        const t = item.querySelector('[data-itcc-shopall-cat-trigger]');
        if (t) t.setAttribute('aria-expanded', active ? 'true' : 'false');
      });

      const empty = menu ? menu.querySelector('[data-itcc-shopall-empty]') : null;
      if (empty) empty.hidden = Boolean(handle);

      const subs = menu ? [...menu.querySelectorAll('[data-itcc-shopall-submenu]')] : [];
      subs.forEach((sub) => {
        const match = Boolean(handle) && sub.getAttribute('data-itcc-shopall-submenu') === handle;
        if (match) hydrateLazyFilters(sub);
        sub.hidden = !match;
      });

      if (handle && menu) {
        const acc = menu.querySelector(`[data-itcc-shopall-acc="${CSS.escape(handle)}"]`);
        if (acc) hydrateLazyFilters(acc);
      }
    };

    const setShopAllOpen = (open) => {
      if (!shopAll || !menu || !trigger) return;
      if (open) hydrateLazyFilters(menu);
      shopAll.classList.toggle('is-open', open);
      menu.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) setShopAllSubOpen(null);
    };

    const setCatOpen = (handle) => {
      openHandle = handle || null;
      nav.classList.toggle('has-mega-open', Boolean(handle));

      catItems.forEach((item) => {
        const h = item.getAttribute('data-itcc-cat-handle');
        const active = Boolean(handle) && h === handle;
        item.classList.toggle('is-open', active);
        const t = item.querySelector('[data-itcc-cat-trigger]');
        if (t) t.setAttribute('aria-expanded', active ? 'true' : 'false');
      });

      megas.forEach((panel) => {
        const match = Boolean(handle) && panel.getAttribute('data-itcc-cat-mega') === handle;
        if (match) hydrateLazyFilters(panel);
        panel.hidden = !match;
      });
    };

    if (shopAll && trigger && menu) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const nextOpen = !shopAll.classList.contains('is-open');
        setCatOpen(null);
        setShopAllOpen(nextOpen);
      });

      shopAllCats.forEach((item) => {
        const handle = item.getAttribute('data-itcc-shopall-cat');
        if (!handle) return;

        const catTrigger = item.querySelector('[data-itcc-shopall-cat-trigger]');
        if (catTrigger) {
          catTrigger.addEventListener('click', (e) => {
            if (!item.classList.contains('has-submenu')) return;
            e.preventDefault();
            e.stopPropagation();
            setShopAllSubOpen(openShopAllHandle === handle ? null : handle);
          });
        }
      });
    }

    if (megas.length) {
      catItems.forEach((item) => {
        const handle = item.getAttribute('data-itcc-cat-handle');
        if (!handle || handle === 'all') return;
        const panel = root.querySelector(`[data-itcc-cat-mega="${CSS.escape(handle)}"]`);
        if (!panel) return;

        const catTrigger = item.querySelector('[data-itcc-cat-trigger]');
        if (catTrigger) {
          catTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            setShopAllOpen(false);
            setCatOpen(openHandle === handle ? null : handle);
          });
        }
      });
    }

    document.addEventListener('click', (e) => {
      if (shopAll && !shopAll.contains(e.target)) setShopAllOpen(false);
      if (megas.length && !nav.contains(e.target)) setCatOpen(null);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      setShopAllOpen(false);
      setCatOpen(null);
    });

    if (!scroller) return;

    let pointerId = null;
    let startX = 0;
    let scrollLeft = 0;
    let dragging = false;
    let suppressClick = false;

    const canScroll = () => scroller.scrollWidth > scroller.clientWidth + 1;

    scroller.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      if (e.button != null && e.button !== 0) return;
      if (!canScroll()) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      scrollLeft = scroller.scrollLeft;
      dragging = false;
      suppressClick = false;
    });

    scroller.addEventListener('pointermove', (e) => {
      if (pointerId == null || e.pointerId !== pointerId) return;
      const dx = e.clientX - startX;

      if (!dragging) {
        if (Math.abs(dx) < 10) return;
        dragging = true;
        suppressClick = true;
        scroller.classList.add('is-dragging');
        try {
          scroller.setPointerCapture(e.pointerId);
        } catch (_) {}
      }

      scroller.scrollLeft = scrollLeft - dx;
    });

    const end = (e) => {
      if (pointerId == null || (e && e.pointerId !== pointerId)) return;
      pointerId = null;
      dragging = false;
      scroller.classList.remove('is-dragging');
    };

    scroller.addEventListener('pointerup', end);
    scroller.addEventListener('pointercancel', end);
    scroller.addEventListener('lostpointercapture', () => {
      pointerId = null;
      dragging = false;
      scroller.classList.remove('is-dragging');
    });

    scroller.addEventListener(
      'click',
      (e) => {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      },
      true
    );
  });
})();
